/**
 * @module app.bdc.list.cancelOrReplaceCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function CancelOrReplaceCtrl($scope, $rootScope, $uibModalInstance, $log, order, Notification, orderService, offerService) {
        var self = {};

        self.showLizMessage = function() {
            return ['RESP TELEPRO', 'AC', 'DC'].indexOf($rootScope.user.role) !== -1;
        }
        self
        self.action = 'replaceOrder';
        self.cancelLiz = false;
        self.order = order;

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        /**
         * Cancel the order
         */
        self.cancelOrder = function cancelOrder() {
            order.cancelLiz = self.cancelLiz;
            orderService
                .cancel(order)
                .then(function(res) {
                    Notification.success(res.message);
                })
                .catch(function(err) {
                    $log.error(err);
                    Notification.error('Une erreur est survenue ' + (err.data ? ': ' + err.data : ''));
                })
                .finally(function() {
                    $uibModalInstance.close();
                });
        };

        /**
         * Replace the order
         */
        self.replaceOrder = function replaceOrder() {
            if (offerService.isOlderOffer(order) === true) {
                Notification.error(
                    'Vous ne pouvez pas remplacer un bon de commande lié à une ancienne offre commerciale.'
                );
                return;
            }
            // if(moment(order.dateCreated).isBefore(moment().subtract(1, 'months'))){
            //     Notification.error('Vous ne pouvez pas remplacer un bon de commande plus ancien que 1 mois.');
            //     return;
            // }
            order.cancelLiz = self.cancelLiz;
            orderService
                .replace(order)
                .then(function(newOrder) {
                    Notification.success(
                        "Le bon de commande a été remplacé. Nouveau bon de commande avec l'id: " + newOrder.id
                    );
                    $uibModalInstance.close(newOrder);
                })
                .catch(function(err) {
                    $log.error(err);
                    Notification.error('Une erreur est survenue ' + (err.data ? ': ' + err.data : ''));
                });
        };

        self.doAction = function(){
            self[self.action]();
        }

        return self;
    }

    CancelOrReplaceCtrl.$inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        '$log',
        'order',
        'Notification',
        'orderService',
        'offerService'
    ];

    angular
        .module('app.bdc.list.cancelOrReplaceCtrl', ['ui.bootstrap.modal', 'ui-notification'])
        .controller('CancelOrReplaceCtrl', CancelOrReplaceCtrl);
});
